import {
    Directive,
    ElementRef,
    Input,
    Inject,
    Renderer,
    OnInit,
    Output,
    EventEmitter,
    HostListener
} from '@angular/core';

import { Global } from '../../../system/services/global';

// add extra methods for the leaflet library
// Generic  Canvas Overlay for leaflet BEFORE INPUT AS PROVIDER
L.CanvasOverlay = L.Class.extend({
    initialize: function (userDrawFunc, options) {
        this._userDrawFunc = userDrawFunc;
        L.setOptions(this, options);
    },
    drawing: function (userDrawFunc) {
        this._userDrawFunc = userDrawFunc;
        return this;
    },
    params:function(options){
        L.setOptions(this, options);
        return this;
    },
    canvas: function () {
        return this._canvas;
    },
    // redraw: function () {
    //     if (!this._frame) {
    //         this._frame = L.Util.requestAnimFrame(this._redraw, this);
    //     }
    //     return this;
    // },
    onAdd: function (map) {
        this._map = map;
        this._canvas = L.DomUtil.create('canvas', 'leaflet-heatmap-layer');

        var size = this._map.getSize();
        this._canvas.width = size.x;
        this._canvas.height = size.y;

        var animated = this._map.options.zoomAnimation && L.Browser.any3d;
        L.DomUtil.addClass(this._canvas, 'leaflet-zoom-' + (animated ? 'animated' : 'hide'));


        map._panes.overlayPane.appendChild(this._canvas);

        map.on('moveend', this._reset, this);
        map.on('resize',  this._resize, this);

        if (map.options.zoomAnimation && L.Browser.any3d) {
            map.on('zoomanim', this._animateZoom, this);
        }

        this._reset();
    },
    onRemove: function (map) {
        map.getPanes().overlayPane.removeChild(this._canvas);

        map.off('moveend', this._reset, this);
        map.off('resize', this._resize, this);

        if (map.options.zoomAnimation) {
            map.off('zoomanim', this._animateZoom, this);
        }
        // this_canvas = null;

    },
    addTo: function (map) {
        map.addLayer(this);
        return this;
    },
    _resize: function (resizeEvent) {
        this._canvas.width  = resizeEvent.newSize.x;
        this._canvas.height = resizeEvent.newSize.y;
    },
    _reset: function () {
        var topLeft = this._map.containerPointToLayerPoint([0, 0]);
        L.DomUtil.setPosition(this._canvas, topLeft);
        this._redraw();
    },
    _redraw: function () {
        var size     = this._map.getSize();
        var bounds   = this._map.getBounds();
        var zoomScale = (size.x * 180) / (20037508.34  * (bounds.getEast() - bounds.getWest())); // resolution = 1/zoomScale
        var zoom = this._map.getZoom();

        // console.time('process');

        if (this._userDrawFunc) {
            this._userDrawFunc(
                this,
                {
                    canvas   :this._canvas,
                    bounds   : bounds,
                    size     : size,
                    zoomScale: zoomScale,
                    zoom : zoom,
                    options: this.options
               }
            );
        }
        // console.timeEnd('process');
        this._frame = null;
    },
    _animateZoom: function (e) {
        var scale = this._map.getZoomScale(e.zoom),
            offset = this._map._getCenterOffset(e.center)._multiplyBy(-scale).subtract(this._map._getMapPanePos());
        this._canvas.style[L.DomUtil.TRANSFORM] = L.DomUtil.getTranslateString(offset) + ' scale(' + scale + ')';
    }
});
L.canvasOverlay = function (userDrawFunc, options) {
    return new L.CanvasOverlay(userDrawFunc, options);
};

@Directive({
    selector: '[map-container]',
    providers: [
        { provide: 'Leaflet',  useValue: L }
    ]
})
export class MapDirective implements OnInit {
    public mapPaths = require('./combined.json');
    private center = [0, 0];
    private zoom = 3;
    private leaflet;
    // canvas
    public canvasLayer;
    public canvas;
    public context;
    // svg
    public svgLayer;
    public siteLayer;
    public height = 0;
    public width = 0;
    // d3
    public transform;
    public path;
    // data
    public animationsArray = [];
    public explosionsArray = [];

    private currentSite;
    @Output() currentSiteIs = new EventEmitter();
    @Output() changeSite = new EventEmitter();
    @Input() private newStream;

    @Input() private parent;
    @Input() private fullscreenEnabled;
    @Input() private sites;
    @Input() private windowIsHidden;

    // data streams
    @Input() private inboundStream;
    @Input() private outboundStream;
    @Input() private lateralStream;
    @Input() private mode;

    @Output() onMapDrag = new EventEmitter();
    constructor(
        private el: ElementRef,
        private renderer: Renderer,
        @Inject('Leaflet') private leafletLib,
        @Inject('Window') private window,
        @Inject('Document') private document: Document,
        @Inject('D3') private d3,
        @Inject('Global') private global
    ) {}
    /////////////////////
    // LIFESTYLE HOOKS //
    /////////////////////
    ngOnInit() {
        // When you zoom out all the way, this line makes the background black
        // (by default it is gray).
        this.renderer.setElementStyle(this.el.nativeElement, 'backgroundColor', 'black');
        // Instantiate the Leaflet map, see docs at
        // http://leafletjs.com/reference.html#map-constructor
        this.leaflet = this.leafletLib.map(this.el.nativeElement, {
            // Turn off the "Leaflet" link in the lower right corner.
            // Leaflet is properly attributed in the README.
            attributionControl: false,
            minZoom: 2,
            worldCopyJump: true
        })
        .setView(this.center, this.zoom)
        // Add the black & white style map layer.
        // Found by browsing http://leaflet-extras.github.io/leaflet-providers/preview/
        // TODO move this to configuration.
        //this.leafletLib.tileLayer("https://stamen-tiles.a.ssl.fastly.net/toner/{z}/{x}/{y}.png").addTo(this.leaflet);
        this.leafletLib.tileLayer("https://watercolormaps.collection.cooperhewitt.org/tile/watercolor/{z}/{x}/{y}.jpg").addTo(this.leaflet);

        this.resizeMapContainer();

        // set append svg and canvas layers to the map
        // canvas layer
        this.canvasLayer = this.leafletLib.canvasOverlay()
            .addTo(this.leaflet); // add this layer to leaflet map
        this.canvas = this.canvasLayer.canvas();
        this.context = this.canvas.getContext('2d');
        // svg layer
        // let svgLayer = this.renderer.createElement(this.leaflet.getPanes().overlayPane, 'svg');
        // this.siteLayer = this.renderer.createElement(this.svgLayer, 'g');
        this.svgLayer = this.d3.select(this.leaflet.getPanes().overlayPane).append("svg");
        // this.defs = this.svg.append('svg:defs');
        this.siteLayer = this.svgLayer.append("g");

        // d3
        let point = this.projectPoint();
        this.transform = this.d3.geo.transform({ point: point })

        this.path = this.d3.geo.path().projection(this.transform);
        this.resizeSvgLayer();

        // init drawing of things
        const sites = this.reduceSites(this.sites);
        const currentSite = this.global.user.settings_global.current.name;
        for (let g = 0, glen = sites.length; g < glen; g++) {
            for (let s = 0, slen = sites[g].length; s < slen; s++) {
                if (currentSite === sites[g][s].site) {
                    this.currentSite = sites[g][s];
                    // emit site change for the parent compoenents
                    this.currentSiteIs.emit({
                        site: this.currentSite
                    })
                    break;
                }
            }
        }

        // do nothing if there isnt a site set by default (something is broken)
        if (!this.currentSite) { return }

        this.drawSites(sites);
        // set current site location
        this.markCurrentSiteBlock(this.currentSite);

        //sub to streams
        this.setupStreams();
        // listen for re-sub events when the site is changed
        this.newStream
            .asObservable()
            .subscribe(() => {
                this.setupStreams();
            })

        // MAP EVENT LISTENERS
        this.leaflet.on("move", () => {
            this.onMove();
            this.clearConnectionsOnMap();
            // send events to globe
            this.onMapDrag.emit({
                center: this.center,
                zoom: this.zoom
            })
        });
        // clear canvas items after map is finished moving
        this.leaflet.on("moveend", () => {
            this.clearConnectionsOnMap();
        });
        this.leaflet.on("viewreset",() => { // Move this outside the function
            // delete all points on the page
            this.wipeClean();
            // reset svg heatmap layer
            this.resizeSvgLayer();
            // this.movePoints();
            const sites = this.reduceSites(this.sites);
            // redraw the sites
            this.drawSites(sites);
            // set current site location
            this.markCurrentSiteBlock(this.currentSite);

            // reset globe inactivity status and send some settings
            this.onMapDrag.emit({
                center: this.center,
                zoom: this.zoom
            })
        });
    }
    ////////////
    // EVENTS //
    ////////////
    setupStreams() {
        // EVENT SUBSCRIPTIONS
        this.inboundStream.subscribe((conn) => {
            if (this.windowIsHidden) { return }
            if (this.mode === "outbound") { return }
            this.drawConnection([conn, this.currentSite], '255, 93, 42', true); // #3459FF
        })
        this.outboundStream.subscribe((conn) => {
            if (this.windowIsHidden) { return }
            if (this.mode === "inbound") { return }
            this.drawConnection([this.currentSite, conn], '52, 89, 255', false); // #FF5D2A
        })
        this.lateralStream.subscribe((conn) => {
            if (this.windowIsHidden) { return }
            if (this.mode !== "all") { return }
            this.explosion(this.currentSite, '170, 55, 178'); // #AA37B2
        })
    }
    onGlobeDrag(event) {
        // set map center when globe is dragged
        this.setCenter(event.value);
    }
    @HostListener('window:resize', ['$event'])
    onWindowResize(event) {
        this.resizeMapContainer();
        // NOTE: because specific clients want the sites' size to change when we go into
        // fullscreen mode, we now have to redraw the sites whenever the window size changes.
        // this is probably really inifficent but large parts of the code would have to be re-written
        // to accomodate this change efficiently
        // delete all points on the page
        this.wipeClean();
        // reset svg heatmap layer
        this.resizeSvgLayer();
        // this.movePoints();
        let sites = this.reduceSites(this.sites);
        // redraw the sites
        this.drawSites(sites);
        // set current site location
        this.markCurrentSiteBlock(this.currentSite);
    }
    /////////////
    // METHODS //
    /////////////
    projectPoint() {
        let leafletLib = this.leafletLib;
        let map = this.leaflet;
        return function(x, y) {
            let point = map.latLngToLayerPoint(new leafletLib.LatLng(y, x));
            this.stream.point(point.x, point.y);
        }
    }
    getCenter() {
        // Returns the current Leaflet map center
        // in a format that D3 understands: [longitude, latitude]
        var center = this.leaflet.getCenter();
        return [center.lng, center.lat];
    }
    onMove() {
        // _.throttle(function (){
            this.center = this.getCenter();
            this.zoom = this.leaflet.getZoom();
            // let bounds = this.leaflet.getBounds();
            // this.longitudeInterval = [bounds.getWest(), bounds.getEast()];
        // }, 100);
    }
    setCenter(center) {
        // Sets the Leaflet map center to be the given center.
        // Note that Leaflet will immediately trigger a "move"
        // event
        this.leaflet.off("move", () => { this.onMove(); });
        this.leaflet.panTo(this.leafletLib.latLng(center[1], center[0]), {
            animate: false
        });
        this.leaflet.on("move", () => { this.onMove() });
    }
    mapBox(box) {
        this.renderer.setElementStyle(this.el.nativeElement, 'width', box.width + 'px');
        this.renderer.setElementStyle(this.el.nativeElement, 'height', box.height + 'px');
        // Tell Leaflet that the size has changed so it updates.
        this.leaflet.invalidateSize();
    }
    zoomTo(coordinates, zoom) {
        this.leaflet.setView([coordinates.lat, coordinates.lng], zoom, { animate: true });
    }
    resizeMapContainer() {
        if (!this.parent) { console.log('Parent attribute not defined in map'); return }
        let parent = this.document.getElementsByClassName(this.parent)[0];
        let width = parent.clientWidth;
        let height = this.window.innerHeight;
        // setTimeout(() => {
           // console.log(this.fullscreenEnabled())
            if (this.fullscreenEnabled()) {
                this.mapBox({ width: width, height: height })
            } else {
                this.mapBox({ width: width, height: height-40 })
            }
        // }, 100)
    }
    resizeSvgLayer() {
        const bounds = this.path.bounds(this.mapPaths),
            topLeft = bounds[0],
            bottomRight = bounds[1];

        // NOTE: leaving these here because i eventually want to replace the d3 selections with the this.renderer
        // this.renderer.setElementAttribute(this.svgLayer, "width", bottomRight[0] - topLeft[0]);
        // this.renderer.setElementAttribute(this.svgLayer, "height", bottomRight[1] - topLeft[1]);
        // this.renderer.setElementStyle(this.svgLayer, "left", topLeft[0] + "px");
        // this.renderer.setElementStyle(this.svgLayer, "top", topLeft[1] + "px");
        // this.renderer.setElementAttribute(this.siteLayer, "transform", "translate(" + -topLeft[0] + "," + -topLeft[1] + ")");

        this.svgLayer
            .attr("width", bottomRight[0] - topLeft[0])
            .attr("height", bottomRight[1] - topLeft[1])
            // .attr("width", 500)
            // .attr("height", 700)
            .style("left", topLeft[0] + "px")
            .style("top", topLeft[1] + "px");

        this.height = bottomRight[1] - topLeft[1];
        this.width = bottomRight[0] - topLeft[0]
        this.siteLayer
            .attr("transform", "translate(" + -topLeft[0] + "," + -topLeft[1] + ")");
    }

    // ANIMATION LAYERS
    clearConnectionsOnMap() {
        this.animationsArray = [];
        this.explosionsArray = [];
    }
    reduceSites(sites) {
        // TODO:
        // - add animation to the break apart and collapse of zones
        const radius = 7;
        // set used index store and groups store
        const usedIndexes = [], groups = [];
        // loop through again
        for (let i = 0, len = sites.length; i < len; i++) {
            // do nothing if this item has been compared against others
            if (usedIndexes.indexOf(i) !== -1) { continue }
            usedIndexes.push(i); // set this index as used
            const current = sites[i]; // alias so things are easier to read
            const matches = new Array(current); // create new array for this item/group
            // loop through all the other items again
            for (let g = 0, glen = sites.length; g < glen; g++) {
                // do nothing if this item has been grouped already
                if (usedIndexes.indexOf(g) !== -1) { continue }
                const other = sites[g]; // set alias
                // run comparison and push to group if they are close enough
                if (
                    (Math.abs(this.leaflet.latLngToLayerPoint(current.LatLng).x - this.leaflet.latLngToLayerPoint(other.LatLng).x) < radius*2) &&
                    (Math.abs(this.leaflet.latLngToLayerPoint(current.LatLng).y - this.leaflet.latLngToLayerPoint(other.LatLng).y) < radius*2)
                ) {
                    matches.push(other);
                    usedIndexes.push(g);
                }
            }
            groups.push(matches);
        }
        return groups;
    }
    drawSites(siteGroups) {
        // some settings change if the page is in fullscreen mode or not
        let sides = 20, groupYTranslate = 15;
        if (this.fullscreenEnabled()) {
            sides = 7, groupYTranslate = 5;
        }
        const group = this.siteLayer
            .selectAll('g')
            .data(siteGroups).enter();
        const site = group.append('g')
            .classed('site', true)
            .attr("transform", (d) => {
                // take the first value from the given array of sites (d[0])
                let y = this.leaflet.latLngToLayerPoint(d[0].LatLng).y - groupYTranslate;
                return "translate("+ this.leaflet.latLngToLayerPoint(d[0].LatLng).x +","+ y +")";
            })
            .on('click', (d) => {
                this.currentSite = d[0];
                // change the site everywhere
                this.changeSite.emit(d);
                // temp fix for the marker not waiting for angular's dirty checking
                this.markCurrentSiteBlock(d);
            })
        // append border
        site.append('rect')
            .classed('site-border', true)
            .attr('width', sides+2)
            .attr('height', sides+2)
            .attr('fill', '#7270cd')
            .attr("transform", "translate(0, -1.5) rotate(45)")

        // append rectangle
        site.append('rect')
            .classed('layer-1', true)
            .attr('width', sides)
            .attr('height', sides)
            .attr('fill', '#7270cd')
            .attr("transform", "rotate(45)") // take the first value from the given array of sites (d[0])
        // dont append text in full screen mode
        if (this.fullscreenEnabled()) { return }
        // appendsite count
        site.append("text")
            .text(function (d) {
                // return the number of sensors that may exist inside this group
                return d.map((s) => { return s.sensors.length }).reduce((a, b) => { return a + b });
            })
            .style('font-family', 'lato')
            // .style("font-size", "12.1em")
            .attr("x", 0)
            .attr("y", 18)
            .attr('fill', '#ffffff')
            // .attr("font-size","1.1em")
            .attr("text-anchor","middle")
    }
    siteExistsInGroup(siteName, group) {
        let exists = false;
        for (let s = 0, len = group.length; s < len; s++) {
            if (siteName.site === group[s].site) {
                exists = true;
                break;
            }
        }
        return exists;
    }
    markCurrentSiteBlock(site) {
        let selected_size = 35, non_selected_size = 22, non_selected_translate = 1.5, selected_translate = 10; // change the size of selected site if in full screen mode
        if (this.fullscreenEnabled()) {
            selected_size = 10, non_selected_size = 9, non_selected_translate = 1.5, selected_translate = 2;
        }
        const group = this.siteLayer.selectAll("g.site");
        // because of our .each() below we need to pull the SiteExists function into
        // this scope, since 'this' is not available
        const siteExistsFun = this.siteExistsInGroup;

        const dashCurrentSite = this.currentSite;
        let d3Local = this.d3;

        // start with coloring the
        group.select('rect.layer-1')
        .attr('fill', (d) => {
            if (siteExistsFun(dashCurrentSite, d)) {
                return '#79CC2E';
            } else {
                // return '#7270cd';
                return '#000';
            }
        })
        .each(function(d) {
            if (!siteExistsFun(dashCurrentSite, d)) {
                const el = d3Local.select(this.parentNode)
                el.select('.site-border')
                    .attr("transform", "translate(0, -"+non_selected_translate+") rotate(45)")
                    .attr('fill', '#79CC2E')
                    .attr('height', non_selected_size)
                    .attr('width', non_selected_size)
            } else {
                // if current site is in this group, mark append the outer grey block
                const el = d3Local.select(this.parentNode);
                el.select('.site-border')
                    .attr("transform", "translate(0, -"+selected_translate+") rotate(45)")
                    .attr('fill', '#000')
                    .attr('height', selected_size)
                    .attr('width', selected_size)
            }
        })
        // change the text color
        group.select('text')
            .attr('fill', (d) => {
                if (siteExistsFun(dashCurrentSite, d)) {
                    return '#000';
                } else {
                    return '#79CC2E';
                }
            })
    }

    // ANIMATION HELPERS
    reverseFib(i, val) {
        let result
        if (i === 1) {
            result = val;
        } else {
            for (; i >= 1; i--) {
                val = val/2;
                if (i === 1) {
                    result = val;
                }
            }
        }
        return result;
    }
    wipeClean() {
        this.siteLayer.selectAll('g.site').remove();
        // remove all virtual dom animations
        this.animationsArray = [];
        this.explosionsArray = [];
    }
    // conncection helper functions
    calculateDistance(coordinates) {
        let dis = Math.sqrt(
            Math.pow((this.leaflet.latLngToLayerPoint(coordinates[1].LatLng).x - this.leaflet.latLngToLayerPoint(coordinates[0].LatLng).x), 2) +
            Math.pow((this.leaflet.latLngToLayerPoint(coordinates[1].LatLng).y - this.leaflet.latLngToLayerPoint(coordinates[0].LatLng).y), 2)
        )
        return dis;
    }
    calculateDirection(coordinates) {
        let dir = Math.atan2(
            this.leaflet.latLngToLayerPoint(coordinates[0].LatLng).y - this.leaflet.latLngToLayerPoint(coordinates[1].LatLng).y,
            this.leaflet.latLngToLayerPoint(coordinates[0].LatLng).x - this.leaflet.latLngToLayerPoint(coordinates[1].LatLng).x
        );
        return dir;
    }
    calculateScale(max) {
        let scale = this.d3.scale.linear().domain([0, max]).range([0, 1]);
        return scale;
    }
    calculateZoom() {
        let zoom = (this.zoom === 0) ? 1 : this.zoom;
        return zoom;
    }
    // main conn drawing function
    public drawConnection(coordinates, color, originExplosion) {
        // let leafletLocal = this.map.leaflet;
        // run explosion if originExplosion is set
        // distance in pixels betweem too points on the page
        const distance = this.calculateDistance(coordinates);
        const radius = 100; // distince outside zone to grow the connection line
        // figure out what value of t is at the radius mark of the overall distance
        // this is the value of t where our scale should be at 1
        const tmax = radius/distance;
        const scale = this.calculateScale(tmax);
        // get zoom level or default to 1
        const zoom = this.calculateZoom();
        // use reverse sequence to determine the original distance at zoom 1;
        // const origDist = this.reverseFib(zoom, distance);
        // get the direction to point the path
        const rotation = this.calculateDirection(coordinates);

        // const maxTime = 9000;
        // const maxDistance = 500;
        // const duration = ((origDist/maxDistance) * maxTime) * (zoom*0.6);
        const duration = 600 * (zoom*0.2);
        let obj = {
            x: {
                start: this.leaflet.latLngToContainerPoint(coordinates[0].LatLng).x,
                end: this.leaflet.latLngToContainerPoint(coordinates[1].LatLng).x,
                distance:
                    this.leaflet.latLngToContainerPoint(coordinates[1].LatLng).x -
                    this.leaflet.latLngToContainerPoint(coordinates[0].LatLng).x
            },
            y: {
                start: this.leaflet.latLngToContainerPoint(coordinates[0].LatLng).y,
                end: this.leaflet.latLngToContainerPoint(coordinates[1].LatLng).y,
                distance:
                    this.leaflet.latLngToContainerPoint(coordinates[1].LatLng).y -
                    this.leaflet.latLngToContainerPoint(coordinates[0].LatLng).y
            },
            dist: distance,
            rotation: rotation,
            duration: duration,
            start: 0,
            color: color,
            tmax: tmax,
            scale: this.d3.scale.linear().domain([0, tmax]).range([0, 1])

        }
        this.addAnimation(obj);
        if (originExplosion) {
            this.explosion(coordinates[0], color);
        }
    }
    addAnimation(obj) {
        this.animationsArray.push(obj);
    }
    removeAnimations(count) {
        // iterate and drop items that are expired
        this.animationsArray.splice(0, count);
    }
    public explosion(coordinates, color) {
        let obj = {
            radius: {
                start: 2,
                end: 40
            },
            opacity: 0.8,
            duration: 3500,
            start: 0,
            color: color,
            x: this.leaflet.latLngToContainerPoint(coordinates.LatLng).x,
            y: this.leaflet.latLngToContainerPoint(coordinates.LatLng).y
        }
        this.addExplosion(obj)
    }
    addExplosion(obj) {
        this.explosionsArray.push(obj);
    }
    removeExplosions(count) {
        // iterate and drop items that are expired
        this.explosionsArray.splice(0, count);
    }

}



/** WEBPACK FOOTER **
 ** ./src/landing/directives/dashboard/map.directive.ts
 **/